namespace Matrix.Indexation {
    export interface DimIndexesRow {
        IndexKey?: number;
        IndexCode?: string;
        Name?: string;
        Generation?: number;
        IsCurrent?: string;
        EffectiveFrom?: string;
        EffectiveTo?: string;
        LocalCurrencyCode?: string;
        IndexTypeCode?: string;
        PriceSource1?: string;
        PriceSource1Id?: string;
        PriceSource1Type?: string;
        PriceSource2?: string;
        PriceSource2Id?: string;
        PriceSource2Type?: string;
        FxOtherCurrency?: string;
        RowId?: number;
        Version?: number;
        CreatedBy?: string;
        CreatedWhen?: string;
        UpdatedBy?: string;
        UpdatedWhen?: string;
        DefaultSortOrder?: number;
        IndexName?: string;
        IndexLocalCurrencyCode?: string;
        IndexIndexTypeCode?: string;
        IndexPriceSource1?: string;
        IndexPriceSource1Id?: string;
        IndexPriceSource2?: string;
        IndexPriceSource2Id?: string;
        IndexFxOtherCurrency?: string;
        IndexRowId?: number;
        IndexDefaultSortOrder?: number;
        LocalCurrencyCodeName?: string;
        LocalCurrencyCodeRowId?: number;
        LocalCurrencyCodeDefaultSortOrder?: number;
        IndexTypeName?: string;
        IndexTypeRowId?: number;
        IndexTypeDefaultSortOrder?: number;
        PriceSource1Name?: string;
        PriceSource1SourceGroup?: string;
        PriceSource1SourceCategory?: string;
        PriceSource1SourceId?: number;
        PriceSource1RowId?: number;
        PriceSource2Name?: string;
        PriceSource2SourceGroup?: string;
        PriceSource2SourceCategory?: string;
        PriceSource2SourceId?: number;
        PriceSource2RowId?: number;
        FxOtherCurrencyName?: string;
        FxOtherCurrencyRowId?: number;
        FxOtherCurrencyDefaultSortOrder?: number;
    }

    export namespace DimIndexesRow {
        export const idProperty = 'IndexKey';
        export const localTextPrefix = 'Indexation.DimIndexes';
        export const deletePermission = 'Administration:General';
        export const insertPermission = 'Administration:General';
        export const readPermission = 'Administration:General';
        export const updatePermission = 'Administration:General';

        export declare const enum Fields {
            IndexKey = "IndexKey",
            IndexCode = "IndexCode",
            Name = "Name",
            Generation = "Generation",
            IsCurrent = "IsCurrent",
            EffectiveFrom = "EffectiveFrom",
            EffectiveTo = "EffectiveTo",
            LocalCurrencyCode = "LocalCurrencyCode",
            IndexTypeCode = "IndexTypeCode",
            PriceSource1 = "PriceSource1",
            PriceSource1Id = "PriceSource1Id",
            PriceSource1Type = "PriceSource1Type",
            PriceSource2 = "PriceSource2",
            PriceSource2Id = "PriceSource2Id",
            PriceSource2Type = "PriceSource2Type",
            FxOtherCurrency = "FxOtherCurrency",
            RowId = "RowId",
            Version = "Version",
            CreatedBy = "CreatedBy",
            CreatedWhen = "CreatedWhen",
            UpdatedBy = "UpdatedBy",
            UpdatedWhen = "UpdatedWhen",
            DefaultSortOrder = "DefaultSortOrder",
            IndexName = "IndexName",
            IndexLocalCurrencyCode = "IndexLocalCurrencyCode",
            IndexIndexTypeCode = "IndexIndexTypeCode",
            IndexPriceSource1 = "IndexPriceSource1",
            IndexPriceSource1Id = "IndexPriceSource1Id",
            IndexPriceSource2 = "IndexPriceSource2",
            IndexPriceSource2Id = "IndexPriceSource2Id",
            IndexFxOtherCurrency = "IndexFxOtherCurrency",
            IndexRowId = "IndexRowId",
            IndexDefaultSortOrder = "IndexDefaultSortOrder",
            LocalCurrencyCodeName = "LocalCurrencyCodeName",
            LocalCurrencyCodeRowId = "LocalCurrencyCodeRowId",
            LocalCurrencyCodeDefaultSortOrder = "LocalCurrencyCodeDefaultSortOrder",
            IndexTypeName = "IndexTypeName",
            IndexTypeRowId = "IndexTypeRowId",
            IndexTypeDefaultSortOrder = "IndexTypeDefaultSortOrder",
            PriceSource1Name = "PriceSource1Name",
            PriceSource1SourceGroup = "PriceSource1SourceGroup",
            PriceSource1SourceCategory = "PriceSource1SourceCategory",
            PriceSource1SourceId = "PriceSource1SourceId",
            PriceSource1RowId = "PriceSource1RowId",
            PriceSource2Name = "PriceSource2Name",
            PriceSource2SourceGroup = "PriceSource2SourceGroup",
            PriceSource2SourceCategory = "PriceSource2SourceCategory",
            PriceSource2SourceId = "PriceSource2SourceId",
            PriceSource2RowId = "PriceSource2RowId",
            FxOtherCurrencyName = "FxOtherCurrencyName",
            FxOtherCurrencyRowId = "FxOtherCurrencyRowId",
            FxOtherCurrencyDefaultSortOrder = "FxOtherCurrencyDefaultSortOrder"
        }
    }
}
